



































import { Component, Vue } from "vue-property-decorator";
import FooterUI from "@/components/FooterUI.vue";
import Makimono from "@/components/Makimono.vue";
import "animate.css/animate.css";
import { TimelineMax } from "gsap";
@Component({
  components: {
    "footer-ui": FooterUI,
    Makimono
  }
})
export default class Epilogue extends Vue {
  $refs!: {
    se: HTMLAudioElement;
  };

  ended = false;

  mounted() {
    document.addEventListener("keypress", this.onKeyPress);

    const tl = new TimelineMax({ repeat: -1 });
    tl.to(".chara-cat", {
      left: "30%",
      delay: 1,
      duration: 8,
      ease: "none"
    });
    tl.to(
      ".chara-cat",
      {
        top: "12%",
        duration: 1.5
      },
      "<"
    );
    tl.to(
      ".chara-cat",
      {
        top: "0%",
        duration: 1,
        repeat: 5,
        yoyo: true,
        ease: "sine.inOut"
      },
      "<1"
    );

    tl.to(
      ".chara-cat",
      {
        top: "-30%",
        duration: 2
      },
      "-=1"
    );
    tl.fromTo(
      ".chara-mouse",
      {
        scaleX: 1
      },
      {
        left: "100%",
        scaleX: 1,
        duration: 4
      },
      "-=1"
    );
    tl.fromTo(
      ".chara-mouse",
      {
        scaleX: -1
      },
      {
        scaleX: -1,
        left: "-15%",
        duration: 4
      }
    );
    tl.to(".chara-dog", {
      right: 0
    });
    tl.to(".chara-dog", {
      delay: 5,
      right: "-20%"
    });
  }

  destroyed() {
    document.removeEventListener("keypress", this.onKeyPress);
  }

  onKeyPress(e: KeyboardEvent) {
    if (e.key === "Enter") {
      this.next();
    } else if (e.key === "r") {
      this.$router.push("/");
    }
  }

  next() {
    this.$router.push("/");
  }
}
